import { forwardRef, type Ref, type SVGProps } from "react";
const IconInitialsOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 24H3c-.6 0-1 .4-1 1s.4 1 1 1h26c.6 0 1-.4 1-1s-.5-1-1-1M6.7 20.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3s-.5-.1-.7-.3l-.8-.8-.8.8c-.2.2-.5.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4l.8-.8-.8-.8c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l.8.8.8-.8c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-.8.8zm12.2.4-3.8-14c-.1-.4-.5-.7-1-.7h-.5c-.5 0-.8.3-1 .7l-3.8 14c-.1.5.2 1.1.7 1.2s1.1-.2 1.2-.7l.9-3.3H16l.9 3.3c.1.4.5.7 1 .7h.3c.6-.1.9-.6.7-1.2M12.3 16l1.6-6.1 1.6 6.1zm17.6 4.7-3.8-14c-.1-.4-.5-.7-1-.7h-.5c-.5 0-.8.3-1 .7l-3.8 14c-.1.5.2 1.1.7 1.2s1.1-.2 1.2-.7l.9-3.3H27l.9 3.3c.1.4.5.7 1 .7h.3c.6-.1.9-.6.7-1.2M23.3 16l1.6-6.1 1.6 6.1z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconInitialsOutlineSVG);
ForwardRef.displayName = "IconInitialsOutline";
export { ForwardRef as IconInitialsOutline };
